/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = { closureDays: 'closureDays', closed: 'closed', open: 'open' }; export default Keys;